// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carrier[data-v-6ea0f2c4]{grid-area:carrier}.carrier__logo[data-v-6ea0f2c4]{-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
module.exports = exports;
